import React, { useState, useContext } from "react";
import axiosInstance from "../services/BaseUrl";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../GlobalContext";
import { postLead } from "../services/Api";
import { useTranslation } from 'react-i18next';

import {
  FaFacebook, FaTwitter, FaLinkedin,
  FaInstagram, FaYoutube, FaTiktok,
} from "react-icons/fa";
import Footer from "../components/Footer";

export default function ContactUs() {
  const navigate = useNavigate();
  const { addLead } = useContext(GlobalContext);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const { t, i18n } = useTranslation();

  const [sending, setSending] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

 const handleSubmit = async (e) => {
  e.preventDefault();
  setSending(true);
  try {
    const res = await axiosInstance.post("/contact-us/", form);
    if (res.data.success) {
      setForm({ name: "", email: "", phone: "", message: "" });

      const leadRes = await postLead({
        full_name: form.name,
        contact_number: form.phone,
        lead_type: "email",
        inquiry_link: window.location.href,
        email: form.email, // Add if required by API
        message: form.message, // Add if required by API
      });

      if (leadRes.success && leadRes.data) {
        addLead(leadRes.data);
      } else {
        console.error("Lead API validation errors:", leadRes.error);
      }

      navigate("/thank-you");
    } else {
      alert(res.data.message || "Failed to send message.");
    }
  } catch (err) {
    console.error(err);
    alert("An error occurred while sending your message.");
  } finally {
    setSending(false);
  }
};


  return (
    <>
      <div className="min-h-screen bg-gray-50 py-20 px-4">
      {/* Header */}
<div className="max-w-2xl mx-auto text-center mb-12">
  <h2 className="text-4xl font-bold mb-4">
    {t('contact.get_in_touch', 'Get in Touch')}
  </h2>
  <p className="text-gray-600">
    {t('contact.question_info', 'Have a question or need more info? Fill out the form below and we\'ll get back to you shortly.')}
  </p>
</div>


      {/* Content Grid */}
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Contact Details */}
        <div className="space-y-6">
          <div className="flex items-start space-x-4">
            <FiMapPin className="text-2xl text-teal-600 mt-1" />
            <div>
              <h4 className="font-semibold">Address</h4>
              <p className="text-gray-600">Al Ameri Tower - 7th Floor, Barsha Heights
Dubai, United Arab Emirates</p>
            </div>
          </div>
          <div className="flex items-start space-x-4">
            <FiPhone className="text-2xl text-teal-600 mt-1" />
            <div>
              <h4 className="font-semibold">Phone</h4>
              <p className="text-gray-600">+971 55 255 4245</p>
            </div>
          </div>
          <div className="flex items-start space-x-4">
            <FiMail className="text-2xl text-teal-600 mt-1" />
            <div>
              <h4 className="font-semibold">Email</h4>
              <p className="text-gray-600">info@justoffplan.ai</p>
            </div>
          </div>

           

          {/* Social Icons */}
          <div className="flex space-x-4 mt-4">
            <a href="https://www.facebook.com/profile.php?id=61575864781603" aria-label="Facebook" className="text-gray-500 hover:text-teal-600">
              <FaFacebook size={24} />
            </a>
            <a href="https://www.youtube.com/@Justoffplan" aria-label="YouTube" className="text-gray-500 hover:text-teal-600">
              <FaYoutube size={24} />
            </a>
            <a href="https://www.tiktok.com/@justoffplan" aria-label="TikTok" className="text-gray-500 hover:text-teal-600">
              <FaTiktok size={24} />
            </a>
            <a href="linkedin.com/company/offplan-ai " aria-label="LinkedIn" className="text-gray-500 hover:text-teal-600">
              <FaLinkedin size={24} />
            </a>
            <a href="https://www.instagram.com/justoffplan?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" aria-label="Instagram" className="text-gray-500 hover:text-teal-600">
              <FaInstagram size={24} />
            </a>
          </div>
        </div>
        

        {/* Contact Form */}
       <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 mb-1">Name</label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-400"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-400"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Phone</label>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-400"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Message</label>
              <textarea
                name="message"
                rows="5"
                value={form.message}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-400"
              />
            </div>
            <button
              type="submit"
              disabled={sending}
              className="w-full py-3 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition disabled:opacity-50"
            >
              {sending ? "Sending…" : "Send Message"}
            </button>
          </form>
      </div>
    
    </div>
      <Footer />
    </>
  )
}
